
// Import vendor modules.
import Alpine from "@alpinejs/csp";
import htmx from "htmx.org";

// Import application styles. The shared, foundational styles need to be imported first
// so that the page-specific styles (globbed below) can win the CSS cascade.
import "../_shared/js/xMetaEnterSubmit.js";
import "../_shared/js/xScrollTo.js";
import "../_shared/less/fonts.less";
import "../_shared/less/theme.less";
import "../_shared/less/design-system.less";
import "../_shared/less/core.less";
import "../_shared/tag/localDevelopment.view.less";

import "./**/*.view.{js,less}";

// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //

// Configure HTMX for the application.
htmx.config.history = false;
// Note: the indicator CSS is being driven by <meta> tags now, and has to be, since the
// CSS injection is done during the HTMX initialization prior to this file being run. I'm
// leaving it here so that I don't try to collocate the configuration in the future.
// --
// htmx.config.includeIndicatorCSS = false;

window.Alpine = Alpine;
// Note: Alpine.data() components must be registered before Alpine is started.
Alpine.start();
